module.exports = __webpack_public_path__ + "static/media/CovidVault.650b82f2.png";